// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__W4hIM","modalForm":"UpgradeEpcsModal_modalForm__17PME","modalFooter":"UpgradeEpcsModal_modalFooter__1LCAW"};